module.exports = __webpack_public_path__ + "img/12.106c6c99.png";